import script from "./DefaultHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./DefaultHeader.vue?vue&type=script&setup=true&lang=ts"

import "./DefaultHeader.vue?vue&type=style&index=0&id=4fe4c265&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fe4c265"]])

export default __exports__